/**
 * Escapes HTML special characters to prevent XSS attacks
 * Use this when inserting user-controlled data into HTML strings
 */
export function escapeHtml(unsafe: string | null | undefined): string {
  if (unsafe == null) return '';
  return String(unsafe)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

/**
 * Escapes HTML and converts newlines to <br> tags
 * Use for multiline text that should preserve line breaks
 */
export function escapeHtmlWithBreaks(unsafe: string | null | undefined): string {
  if (unsafe == null) return '';
  return escapeHtml(unsafe).replace(/\n/g, '<br>');
}
